import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const duration = 2;

const Loading = ({ size }: { size: "sm" | "md" }) => {
  return (
    <svg
      data-testid="loadingIndicator"
      viewBox="0 0 63 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        "aspect-square overflow-hidden text-brand-gray-900 dark:text-brand-gray-50",
        size === "sm" && "w-6",
        size === "md" && "w-10"
      )}
    >
      <g clipPath="url(#clip0_20_837)">
        <motion.g
          animate={{ opacity: [0, 0.4, 0.8, 0.8, 0.4, 0, 0] }}
          transition={{
            duration,
            repeat: Infinity,
            delay: 0
          }}
          className="w-full h-full"
        >
          <mask
            id="mask0_20_837"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="15"
            width="37"
            height="52"
          >
            <path
              d="M36.0048 15.4077H0V66.9999H36.0048V15.4077Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_20_837)">
            <path
              d="M26.6743 66.9999L36.0048 61.6012V30.8055L9.33051 15.4077L0 20.7964V51.5921L26.6743 66.9999Z"
              fill="currentColor"
            />
          </g>
        </motion.g>
        <motion.g
          animate={{ opacity: [0, 0.2, 0.4, 0.4, 0.2, 0, 0] }}
          transition={{
            duration,
            repeat: Infinity,
            delay: 0.2
          }}
          className="w-full h-full"
        >
          <mask
            id="mask1_20_837"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="20"
            y="7"
            width="31"
            height="48"
          >
            <path
              d="M50.1052 7.26465H20.8862V54.935H50.1052V7.26465Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_20_837)">
            <path
              d="M47.5605 54.935L50.1052 53.4681V22.6625L23.4309 7.26465L20.8862 8.73158V39.5372L47.5605 54.935Z"
              fill="currentColor"
            />
          </g>
        </motion.g>
        <motion.g
          animate={{ opacity: [0, 0.1, 0.2, 0.2, 0.1, 0, 0] }}
          transition={{
            duration,
            repeat: Infinity,
            delay: 0.4
          }}
          className="w-full h-full"
        >
          <mask
            id="mask2_20_837"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="35"
            y="0"
            width="28"
            height="47"
          >
            <path d="M62.6791 0H35.9949V46.2035H62.6791V0Z" fill="white" />
          </mask>
          <g mask="url(#mask2_20_837)">
            <path
              d="M62.6791 46.2035L62.6691 46.2134V15.4078L35.9949 0.00998889L36.0049 0V30.8056L62.6791 46.2035Z"
              fill="currentColor"
            />
          </g>
        </motion.g>
      </g>
    </svg>
  );
};

export default Loading;
